import {
  LIST_SERVICES_SINGLE,
  SELECTED_SERVICES_SINGLE,
  PAYMENT_TYPE_SERVICES_SINGLE,
  TOTAL_PRICE_SERVICES_SINGLE,
  SELECTED_SERVICES_FROM_MAP_SINGLE,
  SERVICE_PRICE_SERVICES_SINGLE
} from "../../Types";

export const setListServices = (payload) => {
  return {
    type: LIST_SERVICES_SINGLE,
    payload: payload,
  };
};
export const setSelectedServices = (payload) => {
  return {
    type: SELECTED_SERVICES_SINGLE,
    payload: payload,
  };
};
export const setPaymentTypeServices = (payload) => {
  return {
    type: PAYMENT_TYPE_SERVICES_SINGLE,
    payload: payload,
  };
};
export const setTotalPriceServices = (payload) => {
  return {
    type: TOTAL_PRICE_SERVICES_SINGLE,
    payload: payload,
  };
};
export const setServicePriceServices = (payload) => {
  return {
    type: SERVICE_PRICE_SERVICES_SINGLE,
    payload: payload,
  };
};
export const setSelectedServicesFromMap = (payload) => {
  return {
    type: SELECTED_SERVICES_FROM_MAP_SINGLE,
    payload: payload,
  };
};


